<template>
  <!-- <div class="maintenance">
    <div class="maintenance__content">
      
    </div>

    <div class="maintenance__text"><img src="@/assets/icons/logo_w.svg" alt="CosmicUp" class="maintenance__logo">
      <h2> Hey! We are under maintenance! </h2>
      <h3> We will be online again soon !</h3></div>
  </div> -->
  <router-view/>
  <AppAndroidBanner></AppAndroidBanner>
</template>

<script>
import { remoteConfig } from './firebase';
import { fetchAndActivate, getValue } from "firebase/remote-config";
import AppAndroidBanner from './components/appAndroidBanner.vue';
export default {
  name: 'App',
  data(){
    return {
      user: null
    }
  },
  components: {
    AppAndroidBanner,
  },
  methods: {
    async checkVersionFromMobile(){
      try {
        await fetchAndActivate(remoteConfig);
        const appVersion = getValue(remoteConfig, 'appVersion');
        const localVersion = localStorage.getItem('appVersion');
        
        // Controlla se è una nuova versione, se non esiste una versione locale, o se è forzato l'aggiornamento
        if(!!localVersion && parseInt(localVersion) < parseInt(appVersion._value)){
          localStorage.setItem('appVersion', appVersion._value);
            window.WTN.clearAppCache(false);
            window.WTN.clearAppCache(true);
            window.location.reload(true);
        } else {
          localStorage.setItem('appVersion', appVersion._value);
        }
    } catch (error) {
        console.error('Error checking app version:', error);
      }
    },
  },
  async mounted(){
    document.title = this.$t('app.title');
    
    // Aggiungi meta tag per prevenire cache
    const metaNoCache = document.createElement('meta');
    metaNoCache.httpEquiv = 'Cache-Control';
    metaNoCache.content = 'no-cache, no-store, must-revalidate';
    document.head.appendChild(metaNoCache);
    
    const metaPragma = document.createElement('meta');
    metaPragma.httpEquiv = 'Pragma';
    metaPragma.content = 'no-cache';
    document.head.appendChild(metaPragma);
    
    const metaExpires = document.createElement('meta');
    metaExpires.httpEquiv = 'Expires';
    metaExpires.content = '0';
    document.head.appendChild(metaExpires);
    
    const gclid = new URLSearchParams(window.location.search).get('gclid');
    const c_id = new URLSearchParams(window.location.search).get('c_id');
    const e_cmpg = new URLSearchParams(window.location.search).get('e_cmpg');
    console.log('e_cmpg', e_cmpg);
    const ref = new URLSearchParams(window.location.search).get('ref');
    const ttclid = new URLSearchParams(window.location.search).get('ttclid');
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    //check if in url has gclid and save it in session storage
    if(gclid){
      localStorage.setItem('gclid', gclid);
    }
    if(c_id){
      localStorage.setItem('c_id', c_id);
    }
    
    if(ttclid){
      localStorage.setItem('ttclid', ttclid);
    }

    if(fbclid){
      localStorage.setItem('fbclid', fbclid);
    }

    if(ref){
      localStorage.setItem('ref', ref);
    }
    
    if(e_cmpg){
      localStorage.setItem('e_cmpg', e_cmpg);
    }

    if(window.WTN && (window.WTN.isAndroidApp || window.WTN.isIosApp)){
      if(window.WTN.isAndroidApp){
        const windowWidth = window.innerWidth;
        if(windowWidth < 768){
          window.WTN.setOrientation({
              orientation: "protrait",
              forceOrientation: true
          });
        } else {
          window.WTN.setOrientation({
              orientation: "landscape",
              forceOrientation: true
          });
        }
      }
      window.appResumeCallback = async () => await this.checkVersionFromMobile();
      window.WTN.appFirstLoad().then(async (value) => {
        if(value){
          await this.checkVersionFromMobile();
        }
      });
    }
    // add window.innderWidth listener to update isMobile in store
    window.addEventListener('resize', () => {
      this.$store.commit('setIsMobile', window.innerWidth <= 768);
    });
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');
@import "@/assets/css/colors.scss";

html, body,
a, button, input, textarea, select, label, [role='button'] {
  -webkit-tap-highlight-color: transparent; // oppure rgba(0,0,0,0)
}

body{
  font-family: 'Nunito Sans', Helvetica, Arial, sans-serif;
  padding: 0;
  margin: 0;
  color: white;
  background: $cinder;

  @media screen and (max-width: 768px){
    overflow-y: hidden;
  }
}


input, button{
  font-family: 'Nunito Sans', Helvetica, Arial, sans-serif;
}

pre{
  margin: 0;
}

.maintenance{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.maintenance__content {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 1px;
    width: 1px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: -42vw -4vh 0px 0px #fff,25vw -41vh 0px 0px #fff,-20vw 49vh 0px 1px #fff,5vw 40vh 1px 1px #fff,29vw 19vh 1px 0px #fff,-44vw -13vh 0px 0px #fff,46vw 41vh 0px 1px #fff,-3vw -45vh 0px 1px #fff,47vw 35vh 1px 0px #fff,12vw -8vh 1px 0px #fff,-34vw 48vh 1px 1px #fff,32vw 26vh 1px 1px #fff,32vw -41vh 1px 1px #fff,0vw 37vh 1px 1px #fff,34vw -26vh 1px 0px #fff,-14vw -49vh 1px 0px #fff,-12vw 45vh 0px 1px #fff,-44vw -33vh 0px 1px #fff,-13vw 41vh 0px 0px #fff,-36vw -11vh 0px 1px #fff,-23vw -24vh 1px 0px #fff,-38vw -27vh 0px 1px #fff,16vw -19vh 0px 0px #fff,28vw 33vh 1px 0px #fff,-49vw -4vh 0px 0px #fff,16vw 32vh 0px 1px #fff,36vw -18vh 1px 0px #fff,-25vw -30vh 1px 0px #fff,-23vw 24vh 0px 1px #fff,-2vw -35vh 1px 1px #fff,-25vw 9vh 0px 0px #fff,-15vw -34vh 0px 0px #fff,-8vw -19vh 1px 0px #fff,-20vw -20vh 1px 1px #fff,42vw 50vh 0px 1px #fff,-32vw 10vh 1px 0px #fff,-23vw -17vh 0px 0px #fff,44vw 15vh 1px 0px #fff,-40vw 33vh 1px 1px #fff,-43vw 8vh 0px 0px #fff,-48vw -15vh 1px 1px #fff,-24vw 17vh 0px 0px #fff,-31vw 50vh 1px 0px #fff,36vw -38vh 0px 1px #fff,-7vw 48vh 0px 0px #fff,15vw -32vh 0px 0px #fff,29vw -41vh 0px 0px #fff,2vw 37vh 1px 0px #fff,7vw -40vh 1px 1px #fff,15vw 18vh 0px 0px #fff,25vw -13vh 1px 1px #fff,-46vw -12vh 1px 1px #fff,-18vw 22vh 0px 0px #fff,23vw -9vh 1px 0px #fff,50vw 12vh 0px 1px #fff,45vw 2vh 0px 0px #fff,14vw -48vh 1px 0px #fff,23vw 43vh 0px 1px #fff,-40vw 16vh 1px 1px #fff,20vw -31vh 0px 1px #fff,-17vw 44vh 1px 1px #fff,18vw -45vh 0px 0px #fff,33vw -6vh 0px 0px #fff,0vw 7vh 0px 1px #fff,-10vw -18vh 0px 1px #fff,-19vw 5vh 1px 0px #fff,1vw 42vh 0px 0px #fff,22vw 48vh 0px 1px #fff,39vw -8vh 1px 1px #fff,-6vw -42vh 1px 0px #fff,-47vw 34vh 0px 0px #fff,-46vw 19vh 0px 1px #fff,-12vw -32vh 0px 0px #fff,-45vw -38vh 0px 1px #fff,-28vw 18vh 1px 0px #fff,-38vw -46vh 1px 1px #fff,49vw -6vh 1px 1px #fff,-28vw 18vh 1px 1px #fff,10vw -24vh 0px 1px #fff,-5vw -11vh 1px 1px #fff,33vw -8vh 1px 0px #fff,-16vw 17vh 0px 0px #fff,18vw 27vh 0px 1px #fff,-8vw -10vh 1px 1px #fff;
  
  /* stars were too big with the layers above but left the code in case no one cares  -- as in, if noone's just that  one other loner who actually cares    */
  
    box-shadow: 24vw 9vh 1px 0px #fff,12vw -24vh 0px 1px #fff,-45vw -22vh 0px 0px #fff,-37vw -40vh 0px 1px #fff,29vw 19vh 0px 1px #fff,4vw -8vh 0px 1px #fff,-5vw 21vh 1px 1px #fff,-27vw 26vh 1px 1px #fff,-47vw -3vh 1px 1px #fff,-28vw -30vh 0px 1px #fff,-43vw -27vh 0px 1px #fff,4vw 22vh 1px 1px #fff,36vw 23vh 0px 0px #fff,-21vw 24vh 1px 1px #fff,-16vw 2vh 1px 0px #fff,-16vw -6vh 0px 0px #fff,5vw 26vh 0px 0px #fff,-34vw 41vh 0px 0px #fff,1vw 42vh 1px 1px #fff,11vw -13vh 1px 1px #fff,48vw -8vh 1px 0px #fff,22vw -15vh 0px 0px #fff,45vw 49vh 0px 0px #fff,43vw -27vh 1px 1px #fff,20vw -2vh 0px 0px #fff,8vw 22vh 0px 1px #fff,39vw 48vh 1px 1px #fff,-21vw -11vh 0px 1px #fff,-40vw 45vh 0px 1px #fff,11vw -30vh 1px 0px #fff,26vw 30vh 1px 0px #fff,45vw -29vh 0px 1px #fff,-2vw 18vh 0px 0px #fff,-29vw -45vh 1px 0px #fff,-7vw -27vh 1px 1px #fff,42vw 24vh 0px 0px #fff,45vw -48vh 1px 0px #fff,-36vw -18vh 0px 0px #fff,-44vw 13vh 0px 1px #fff,36vw 16vh 0px 1px #fff,40vw 24vh 0px 0px #fff,18vw 11vh 0px 0px #fff,-15vw -23vh 1px 0px #fff,-24vw 48vh 0px 1px #fff,27vw -45vh 1px 0px #fff,-2vw -24vh 0px 1px #fff,-15vw -28vh 0px 0px #fff,-43vw 13vh 1px 0px #fff,7vw 27vh 1px 0px #fff,47vw 5vh 0px 0px #fff,-45vw 15vh 1px 1px #fff,-5vw -28vh 0px 1px #fff,38vw 25vh 1px 1px #fff,-39vw -1vh 1px 0px #fff,5vw 0vh 1px 0px #fff,49vw 13vh 0px 0px #fff,48vw 10vh 0px 1px #fff,19vw -28vh 0px 0px #fff,4vw 7vh 0px 0px #fff,21vw 21vh 1px 1px #fff,-15vw -15vh 0px 1px #fff,-6vw -42vh 1px 0px #fff,-15vw 48vh 1px 1px #fff,-23vw 25vh 1px 1px #fff,-48vw 25vh 0px 1px #fff,-31vw -19vh 0px 1px #fff,4vw 37vh 1px 1px #fff,-43vw 28vh 0px 0px #fff,3vw -25vh 0px 1px #fff,-39vw 14vh 0px 1px #fff,-40vw 31vh 0px 1px #fff,35vw -36vh 1px 1px #fff,16vw 49vh 0px 0px #fff,6vw 39vh 0px 0px #fff,3vw -35vh 0px 1px #fff,-44vw -2vh 1px 0px #fff,-6vw 21vh 1px 0px #fff,48vw 9vh 1px 1px #fff,-43vw 30vh 1px 1px #fff,29vw -12vh 1px 1px #fff,-48vw 13vh 1px 0px #fff,-42vw 32vh 1px 1px #fff,34vw 15vh 1px 1px #fff,29vw -37vh 1px 1px #fff,28vw 2vh 0px 0px #fff;
    animation: zoom 16s alternate infinite; 
}

.maintenance__text{
  display: flex;
  justify-self: center;
  align-items: center;
  flex-direction: column;
}

@keyframes zoom {
    0%{
        transform: scale(1);
    }
    100%{
        transform: scale(1.5);
    }
}

@media screen and (max-width: 768px){
  #crisp-chatbox {
    display: none !important;
  }
  
}
</style>
